import Vue from 'vue'
import App from './App.vue'
import router from './router'

import VueParticlesBg  from "particles-bg-vue";

Vue.config.productionTip = false
Vue.use(VueParticlesBg)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
